import { render, staticRenderFns } from "./MakeReservation.vue?vue&type=template&id=8f67837c"
import script from "./MakeReservation.vue?vue&type=script&lang=js"
export * from "./MakeReservation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports